import { Select, SelectProps } from '@mui/material'
import { ReactNode, forwardRef, useState } from 'react'
import ArrowRoundBlackSvg from '~/@ui/_sharedSvgs/ui/ArrowRoundBlack.svg?react'

export type StyledSelectProps = {
  children?: ReactNode
  className?: string
  showArrow?: boolean
} & SelectProps

export const StyledSelect = forwardRef<HTMLDivElement, StyledSelectProps>(
  (
    {
      children,
      className = '',
      value,
      showArrow = false,
      onOpen,
      onClose,
      error,
      ...rest
    },
    ref
  ) => {
    const isPlaceholder = value === '' || value === undefined || value === null
    const [isOpen, setIsOpen] = useState(false)

    const handleOpen = (event: any) => {
      setIsOpen(true)
      onOpen?.(event)
    }

    const handleClose = (event: any) => {
      setIsOpen(false)
      onClose?.(event)
    }

    return (
      <Select
        ref={ref}
        className={className}
        value={value}
        displayEmpty
        onOpen={handleOpen}
        onClose={handleClose}
        sx={(theme) => ({
          flexShrink: 0,
          width: '108px',
          height: '56px',
          px: '16px',
          py: '15px',
          fontSize: '16px',
          lineHeight: '26px',
          fontWeight: 500,
          color: isPlaceholder
            ? theme.palette.custom.zGrey400
            : theme.palette.custom.zBlack200,
          backgroundColor: theme.palette.custom.zGrey200,
          borderRadius: '20px',
          outline: error
            ? `2px solid ${theme.palette.custom.zRedError}`
            : 'none',
          outlineOffset: '0',
          '& .MuiSelect-select': {
            display: 'flex',
            flexDirection: 'row',
            gap: '8px',
            alignItems: 'center',
          },
          '& .MuiSvgIcon-root': {
            display: 'none',
          },
          '& .MuiOutlinedInput-notchedOutline': {
            border: 'none',
          },
          '&:hover .MuiOutlinedInput-notchedOutline': {
            border: 'none',
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            border: 'none',
          },
        })}
        MenuProps={{
          sx: {
            '& .MuiPaper-root': {
              width: '236px',
              marginTop: '7px',
              marginLeft: '0px',
              backgroundColor: '#F4F4FF',
              boxShadow: 'inset 0 0 0 1px #E0E5EC',
              borderRadius: '20px',
              overflow: 'hidden',
            },
            '& .MuiMenu-list': {
              padding: 0,
            },
          },
        }}
        IconComponent={() =>
          showArrow ? (
            <ArrowRoundBlackSvg
              style={{
                transform: `rotate(${isOpen ? '180deg' : '0deg'})`,
                transition: 'transform 0.2s ease',
                pointerEvents: 'none',
              }}
            />
          ) : null
        }
        {...rest}
        error={error}>
        {children}
      </Select>
    )
  }
)

StyledSelect.displayName = 'StyledSelect'
